import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
  AddRemoveButton,
  ButtonWrapper,
  GroupOverlayCenter,
  GroupOverlayInner,
  RequiredLabel,
  SVGWrapper,
  Td,
  TdPrice,
  Title,
  Tr
} from '../managedITServices/components/css';
import RemoveSVG from '../managedITServices/assets/svg/remove';
import AddSVG from '../managedITServices/assets/svg/add';
import { deleteQuestion } from '../managedITServices/components/saveSchemaToDB';
import { Button } from '../../css';

const CategoryOption = ({
  microsoftLicensingAdminData,
  setMicrosoftLicensingAdminData,
  categoryName,
  categoryIndex,
  isLast,
  isFirst,
  initialData,
  setInitialData,
  deleteCategories,
  setDeleteCategories
}) => {
  const [categoryLabel, setCategoryLabel] = useState(categoryName);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleAddOption = () => {
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    clonedAdminData.push({
      id: '',
      name: '',
      productCatalogOptions: [
        {
            questionId:'',
          id: '',
          name: '',
          productCatalogPricings: [{
            optionId:'',
            id:'',
            cost: 0,
            onetimePrice: 0,
            costPremium: 0,
            onetimePricePremium: 0,
            operationType: 'ADD'
          }]
        }
      ]
    });
    setMicrosoftLicensingAdminData(clonedAdminData);
  };

  const handleRemoveOption =async  () => {
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    const optionId = clonedAdminData[categoryIndex].id;
    if(optionId)
    {
        setDeleteCategories(prevData=>[...prevData,optionId]);
    }
    clonedAdminData.splice(categoryIndex, 1);
    setMicrosoftLicensingAdminData(clonedAdminData);
    setShowOverlay(false);
  };

  const handleNameChange = value => {
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    clonedAdminData[categoryIndex].name = value;
    setMicrosoftLicensingAdminData(clonedAdminData);
  };

  useEffect(() => {
    if(categoryLabel.trim())
    handleNameChange(categoryLabel);
  }, [categoryLabel]);

  useEffect(()=>{
    if(microsoftLicensingAdminData.length === 0)
    {
        handleAddOption();
    }
},[microsoftLicensingAdminData]);

  return (
    <>
    {showOverlay && (
        <GroupOverlayCenter>
          <GroupOverlayInner>
            <Title>
            Deleting this category will also delete all subscriptions under it. Are you sure you want to proceed?
            </Title>
            <ButtonWrapper>
              <Button variant="secondary" onClick={() => setShowOverlay(false)}>
                Cancel
              </Button>
              <Button onClick={handleRemoveOption}>Delete</Button>
            </ButtonWrapper>
          </GroupOverlayInner>
        </GroupOverlayCenter>
      )}
      {isFirst ? (
        <>
        <Td>
          <input
            type="text"
            value={categoryLabel}
            style={{
              borderColor: categoryLabel ? '#e4e4e4' : '#C12335'
            }}
            onChange = {(e) => setCategoryLabel(e.target.value)}
          />
          {!categoryLabel && <RequiredLabel>Required</RequiredLabel>}
          </Td>
          <Td></Td>
          <TdPrice>
            <AddRemoveButton>
              {!isLast && (<SVGWrapper onClick={() => setShowOverlay(true)}>
                <RemoveSVG />
              </SVGWrapper>)}
              {isLast && (
                <SVGWrapper onClick={handleAddOption}>
                  <AddSVG />
                </SVGWrapper>
              )}
            </AddRemoveButton>
          </TdPrice>
        </>
      ) : (
        <Tr>
          <Td></Td>
          <Td>
            <input
              type="text"
              value={categoryLabel}
              style={{
                borderColor: categoryLabel ? '#e4e4e4' : '#C12335'
              }}
              onChange={e => setCategoryLabel(e.target.value)}
            />
            {!categoryLabel && <RequiredLabel>Required</RequiredLabel>}
          </Td>
          <Td></Td>
          <TdPrice>
            <AddRemoveButton>
              <SVGWrapper onClick={() => setShowOverlay(true)}>
                <RemoveSVG />
              </SVGWrapper>
              {isLast && (
                <SVGWrapper onClick={handleAddOption}>
                  <AddSVG />
                </SVGWrapper>
              )}
            </AddRemoveButton>
          </TdPrice>
        </Tr>
      )}
    </>
  );
};

export default CategoryOption;
